// src/components/SeasonManager.js
import React from 'react';
import { startSeason, endSeason, deleteSeason } from '../services/api';

export default function SeasonManager({ seasons, onUpdate }) {
    const handleStart = async (id) => {
        if (window.confirm('Вы уверены, что хотите начать этот сезон? Все остальные активные сезоны будут завершены без сохранения результатов.')) {
            await startSeason(id);
            onUpdate();
        }
    };

    const handleEnd = async (id) => {
        if (window.confirm('Вы уверены, что хотите завершить этот сезон? Это действие необратимо.')) {
            await endSeason(id);
            onUpdate();
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('ВНИМАНИЕ!\n\nВы уверены, что хотите удалить этот сезон?\n\nЭто действие НАВСЕГДА удалит сам сезон и ВСЕ связанные с ним начисления очков. Отменить это будет невозможно.')) {
            try {
                await deleteSeason(id);
                onUpdate(); // Вызываем onUpdate, чтобы родительский компонент перезагрузил данные
            } catch (error) {
                console.error("Ошибка при удалении сезона:", error);
                alert("Не удалось удалить сезон.");
            }
        }
    };

    const renderSeasonList = (seasonList, title) => (
        <div className="season-list-container">
            <h6>{title}</h6>
            {seasonList.length === 0 ? <p className="no-seasons">Нет сезонов</p> : (
                <ul className="season-list">
                    {seasonList.map(s => (
                        <li key={s.id} className={`season-item status-${s.status.toLowerCase()}`}>
                            <span>{s.name}</span>
                            <div className="season-actions">
                                {s.status === 'PLANNED' && <button onClick={() => handleStart(s.id)}>Начать</button>}
                                {s.status === 'ACTIVE' && <button className="end-button" onClick={() => handleEnd(s.id)}>Завершить</button>}
                                {s.status === 'ARCHIVED' && (
                                    <button className="delete-button" onClick={() => handleDelete(s.id)}>
                                        Удалить
                                    </button>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );

    return (
        <div className="season-manager">
            {renderSeasonList(seasons.filter(s => s.status === 'ACTIVE'), 'Активный сезон')}
            {renderSeasonList(seasons.filter(s => s.status === 'PLANNED'), 'Запланированные')}
            {renderSeasonList(seasons.filter(s => s.status === 'ARCHIVED'), 'Архив')}
        </div>
    );
}